import TextField from '@mui/material/TextField';
import { useState } from 'react';
import { CloudGroupSearch } from '../../../_api';
import { DataTable } from '../../../../../components/UI/MDC/DataTable/DataTable';
import Spinner from '../../../../../components/UI/Spinner/Spinner';
import { Button } from '@upmc/ims.component-library';

const SearchResults = ({ options, isLoading, handleSelect }) => {
	const headers = [
		{ Value: 'ID', props: { sort: null, onSortChange: null } },
		{
			Value: 'Display Name',
			props: { sort: null, onSortChange: null },
		},
		{
			Value: 'Action',
			props: { sort: null, onSortChange: null },
		},
	];
	const rows = options.map(option => {
		return {
			Cells: {
				ID: {
					Value: option.ID,
					Validation: {
						Key: 'true',
						Value: null,
						memberToValidateKey: null,
					},
				},
				'Display Name': {
					Value: option.DisplayName,
					Validation: {
						Key: 'true',
						Value: null,
						memberToValidateKey: null,
					},
				},
				Action: {
					Value: (
						<Button onClick={e => handleSelect(option)}>
							Select
						</Button>
					),
					Validation: {
						Key: 'true',
						Value: null,
						memberToValidateKey: null,
					},
				},
			},
			Key: option.ID.toString(),
		};
	});

	return (
		<>
			{isLoading ? (
				<Spinner />
			) : (
				<DataTable rows={rows} headers={headers} />
			)}
		</>
	);
};

const DistributionListsSearch = ({ handleSelect }) => {
	const [searchTerm, setSearchTerm] = useState(null);
	const [options, setOptions] = useState([]);
	const [isLoading, setIsloading] = useState(false);
	const handleSearchChange = e => {
		setSearchTerm(e.target.value);
	};

	const handleSearch = e => {
		e.preventDefault();

		setIsloading(true);
		CloudGroupSearch(searchTerm, true)
			.then(data => setOptions(data))
			.then(() => {
				setIsloading(false);
			});
	};

	return (
		<>
			<form onSubmit={handleSearch}>
				<h4>Select Distribution List</h4>
				<TextField
					variant='filled'
					placeholder={'Search Distribution Lists'}
					onChange={handleSearchChange}
					id='DistributionListSearch'
				/>
			</form>
			<SearchResults
				options={options}
				isLoading={isLoading}
				handleSelect={handleSelect}
			/>
		</>
	);
};

export default DistributionListsSearch;
